import React from 'react';
import { motion } from 'framer-motion';
interface FadeInProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
}
export function FadeIn({
  children,
  className = '',
  delay = 0,
  direction = 'up'
}: FadeInProps) {
  const yOffset = direction === 'up' ? 16 : direction === 'down' ? -16 : 0;
  const xOffset = direction === 'left' ? 16 : direction === 'right' ? -16 : 0;
  return <motion.div initial={{
    opacity: 0,
    y: yOffset,
    x: xOffset
  }} whileInView={{
    opacity: 1,
    y: 0,
    x: 0
  }} viewport={{
    once: true,
    margin: '-30px'
  }} transition={{
    duration: 0.45,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-342">
      {children}
    </motion.div>;
}